import { api } from './client';

export interface SessionSummary {
  session_id: string;
  username: string;
  input_tokens: number;
  output_tokens: number;
  total_tokens: number;
  started_at: string;
  model: string;
  percent_of_session_limit: number;
}

export interface WeeklySummary {
  total_tokens: number;
  input_tokens: number;
  output_tokens: number;
  percent_of_weekly_limit: number;
  window_start: string;
}

export interface ClaudeLimits {
  weekly_token_limit: number;
  session_token_limit: number;
}

export async function fetchClaudeUsage(): Promise<{ sessions: SessionSummary[]; weekly: WeeklySummary }> {
  const { data } = await api.get<{ sessions: SessionSummary[]; weekly: WeeklySummary }>('/claude/usage');
  return data;
}

export async function fetchClaudeLimits(): Promise<ClaudeLimits> {
  const { data } = await api.get<ClaudeLimits>('/claude/limits');
  return data;
}

export async function triggerClaude(step: 'claude' | 'git', wp_id: string): Promise<{ job_id: string }> {
  const { data } = await api.post<{ job_id: string }>('/claude/wp/trigger', { step, wp_id });
  return data;
}

export async function wpNext(): Promise<Record<string, unknown>> {
  const { data } = await api.get<Record<string, unknown>>('/dev/wps/next');
  return data;
}

export async function wpClaim(wpNumber: string): Promise<Record<string, unknown>> {
  const { data } = await api.post<Record<string, unknown>>(`/dev/wps/${wpNumber}/claim`);
  return data;
}

export async function wpComplete(wpNumber: string, note?: string): Promise<Record<string, unknown>> {
  const { data } = await api.post<Record<string, unknown>>(`/dev/wps/${wpNumber}/complete`, { note });
  return data;
}

export async function wpRelease(wpNumber: string): Promise<Record<string, unknown>> {
  const { data } = await api.post<Record<string, unknown>>(`/dev/wps/${wpNumber}/release`);
  return data;
}

export async function wpNextNumber(): Promise<{ next_wp: string }> {
  const { data } = await api.get<{ next_wp: string }>('/dev/wps/nextWpNumber');
  return data;
}

export async function wpReply(wpId: string, text: string): Promise<{ ok: boolean; reason?: string }> {
  const { data } = await api.post<{ ok: boolean; reason?: string }>('/claude/wp/reply', { wp_id: wpId, text });
  return data;
}
